
import Vue from 'vue'
import Transformer from '@/transformers/transformer'

class HighwaySupplyTransformer extends Transformer {
	static fetch(hSupply) {
		let provider = hSupply.provider
		provider = {
			id: provider.SupplyHighway_provider_id,
			name: provider.SupplyHighway_provider_name,
		}

		return {
			...hSupply,
			provider,
			campId: hSupply.camp.SupplyCamp_camp_id,
			campName: hSupply.camp.SupplyCamp_camp_name,
			providerName: provider.name,
			providerId: provider.id,
			price: +hSupply.price,
		}
	}
}

export default (supplyId, params) => {

	return Vue.$http.get(`purchase/supplycamp/getsupplies/${supplyId}/`,
		{params})
		.then(response =>{
			const data = response.data
			const ser = HighwaySupplyTransformer.fetchCollection(data)
			return ser
		})
}


// WEBPACK FOOTER //
// ./src/services/purchase/supplyhighway/fetchSupplyHighwaySupplies.js